import { useEffect, useState } from "react";
import useScrollTop from "../../hooks/useScrollTop";
import "./styles/Issues.css";
import instance from "../../axios";
import { getUserToken } from "../../utils/userAuthenticate";
import { useTranslation } from "react-i18next";
import "../../localisation/index"
const Issues = () => {
  useScrollTop();
  const {t} = useTranslation()

  const [supportURL, setSupportUrl] = useState("");

  const getKycStatus = async () => {
    const url = "/kyc/status";
    const headers = {
      Authorization: getUserToken(),
    };

    try {
      const res = await instance.post(url, {}, { headers });

      if (res?.status === 200) {
        const resData = res.data;

        if (resData?.code === 401) {
          throw new Error(t("errors.authenticationError"));
        }
        if (resData?.code === 403) {
          throw new Error(t("errors.sessionError"));
        }

        // for any other error
        if (resData?.code !== 200) {
          throw new Error(t("errors.serverError"));
        }

        setSupportUrl(resData?.data?.support_url || "");
      }
    } catch (error) {
      console.log(error);
      // setIsError(error.message);
    }
  };
  useEffect(() => {
    getKycStatus();
  }, []);

  return (
    <div className="issues-container component">
      <div className="component-primary-heading">{t("issues.haveIssue")}</div>
      <div className="section-box-container">
        <p>{t("issues.reachOut")}</p>
        <p>
          {t("issues.access")},{" "}
          <a href={supportURL} target="_blank" rel="noreferrer">
            {t("issues.click")}
          </a>
        </p>
      </div>
    </div>
  );
};

export default Issues;
